import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.updateIcons()

    // Écouter les changements de thème
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.updateIcons()
        }
      })
    })

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })
  }

  updateIcons() {
    const isDark = document.documentElement.classList.contains('dark')

    this.iconTargets.forEach(iconElement => {
      const channelId = iconElement.dataset.channelId
      const defaultIcon = iconElement.dataset.defaultIcon
      const whiteIcon = iconElement.dataset.whiteIcon

      if (isDark && whiteIcon && whiteIcon.trim() !== '') {
        iconElement.src = whiteIcon
      } else {
        iconElement.src = defaultIcon
      }
    })
  }
}